// extracted by mini-css-extract-plugin
export var content = "_pf-1";
export var noScroll = "_pf-3";
export var paper = "_pf-0";
export var scrollable = "_pf-2";